// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.new-customer h3{font-size:1.2rem;margin:0;font-weight:700}.new-customer p{margin:0}.new-customer a{display:flex;justify-content:center;text-decoration:none}.new-customer a button{font-size:1.1rem;padding-right:25px;padding-left:25px;padding-top:5px;padding-bottom:5px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
